(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/regenerator', 'babel-runtime/helpers/asyncToGenerator', 'babel-runtime/helpers/classCallCheck', 'babel-runtime/helpers/createClass', 'babel-runtime/helpers/possibleConstructorReturn', 'babel-runtime/helpers/inherits', 'react', './utils'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/regenerator'), require('babel-runtime/helpers/asyncToGenerator'), require('babel-runtime/helpers/classCallCheck'), require('babel-runtime/helpers/createClass'), require('babel-runtime/helpers/possibleConstructorReturn'), require('babel-runtime/helpers/inherits'), require('react'), require('./utils'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.asyncToGenerator, global.classCallCheck, global.createClass, global.possibleConstructorReturn, global.inherits, global.react, global.utils);
    global.AuthFlowProvider = mod.exports;
  }
})(this, function (exports, _regenerator, _asyncToGenerator2, _classCallCheck2, _createClass2, _possibleConstructorReturn2, _inherits2, _react, _utils) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.AuthConsumer = exports.AuthProvider = undefined;
  var _regenerator2 = _interopRequireDefault(_regenerator);
  var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
  var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
  var _createClass3 = _interopRequireDefault(_createClass2);
  var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
  var _inherits3 = _interopRequireDefault(_inherits2);
  var _react2 = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /* global fetch */
  var ANONYMOUS_ROLE = 'ANONYMOUS';
  var DEFAULT_SESSION_CHECK_INTERVAL = 2 * 60 * 1000;
  var AuthContext = _react2.default.createContext();
  var AuthProvider = AuthContext.Provider,
    AuthConsumer = AuthContext.Consumer;
  exports.AuthProvider = AuthProvider;
  exports.AuthConsumer = AuthConsumer;
  var AuthFlowProvider = function (_Component) {
    (0, _inherits3.default)(AuthFlowProvider, _Component);
    function AuthFlowProvider(props) {
      (0, _classCallCheck3.default)(this, AuthFlowProvider);
      var _this = (0, _possibleConstructorReturn3.default)(this, (AuthFlowProvider.__proto__ || Object.getPrototypeOf(AuthFlowProvider)).call(this, props));
      _this.state = {
        authReady: false,
        isLoggedIn: false,
        me: null,
        error: null
      };
      _this.sessionIntervalId = null;
      _this.fetchSession = _this.fetchSession.bind(_this);
      return _this;
    }
    (0, _createClass3.default)(AuthFlowProvider, [{
      key: 'fetchSession',
      value: function () {
        var _ref = (0, _asyncToGenerator3.default)(/*#__PURE__*/_regenerator2.default.mark(function _callee() {
          var _props, apolloClient, query, authReady, _ref2, token, _ref3, me, errors, _ref4, role, isLoggedIn;
          return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _props = this.props, apolloClient = _props.apolloClient, query = _props.query;
                  authReady = this.state.authReady;
                  _context.prev = 2;
                  _context.next = 5;
                  return fetch(process.env.REACT_APP_AUTH_FLOW_BASE_URI + '/session', {
                    method: 'POST',
                    mode: 'cors',
                    credentials: 'include'
                  }).then(function (r) {
                    if (!r.ok) {
                      throw new Error('Session request failed');
                    }
                    return r.json();
                  });
                case 5:
                  _ref2 = _context.sent;
                  token = _ref2.token;
                  if (token) {
                    _context.next = 11;
                    break;
                  }
                  this.setState({
                    authReady: true,
                    isLoggedIn: false
                  });
                  _context.next = 22;
                  break;
                case 11:
                  (0, _utils.setToken)(token);
                  _context.next = 14;
                  return apolloClient.query({
                    query: query || _utils.GET_USER_DATA
                  });
                case 14:
                  _ref3 = _context.sent;
                  me = _ref3.data.me;
                  errors = _ref3.errors;
                  _ref4 = me || {}, role = _ref4.role;
                  if (!errors) {
                    _context.next = 20;
                    break;
                  }
                  throw new Error('Error retrieving ME payload');
                case 20:
                  isLoggedIn = !(role && role === ANONYMOUS_ROLE);
                  this.setState({
                    authReady: true,
                    isLoggedIn: isLoggedIn,
                    me: me
                  });
                case 22:
                  _context.next = 28;
                  break;
                case 24:
                  _context.prev = 24;
                  _context.t0 = _context['catch'](2);
                  (0, _utils.clearToken)();
                  this.setState({
                    authReady: authReady,
                    isLoggedIn: false,
                    me: null,
                    error: _context.t0
                  });
                case 28:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this, [[2, 24]]);
        }));
        function fetchSession() {
          return _ref.apply(this, arguments);
        }
        return fetchSession;
      }()
    }, {
      key: 'componentDidMount',
      value: function () {
        var _ref5 = (0, _asyncToGenerator3.default)(/*#__PURE__*/_regenerator2.default.mark(function _callee2() {
          var _props$sessionCheckIn, sessionCheckInterval;
          return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return this.fetchSession();
                case 3:
                  _context2.next = 7;
                  break;
                case 5:
                  _context2.prev = 5;
                  _context2.t0 = _context2['catch'](0);
                case 7:
                  _props$sessionCheckIn = this.props.sessionCheckInterval, sessionCheckInterval = _props$sessionCheckIn === undefined ? DEFAULT_SESSION_CHECK_INTERVAL : _props$sessionCheckIn;
                  this.sessionIntervalId = setInterval(this.fetchSession, sessionCheckInterval);
                case 9:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[0, 5]]);
        }));
        function componentDidMount() {
          return _ref5.apply(this, arguments);
        }
        return componentDidMount;
      }()
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.sessionIntervalId) {
          clearInterval(this.sessionIntervalId);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state = this.state,
          authReady = _state.authReady,
          isLoggedIn = _state.isLoggedIn,
          me = _state.me,
          error = _state.error;
        return _react2.default.createElement(AuthProvider, {
          value: {
            authReady: authReady,
            isLoggedIn: isLoggedIn,
            me: me,
            error: error
          }
        }, this.props.children);
      }
    }]);
    return AuthFlowProvider;
  }(_react.Component);
  exports.default = AuthFlowProvider;
});